import { AnimatePresence, motion } from "framer-motion";
import { Mail } from "lucide-react";
import { useState } from "react";

export default function ModalForgotPassword({ isModalOpen, setIsModalOpen, setSuccesEmail, setErrorEmail }) {

  const [correo, setCorreo] = useState("")
  const [error, setError] = useState("")

  const handleSubmit = (e) => {
    e.preventDefault()
    try {
      if(!correo) {
        setError("Es necesario ingresar el correo")
        return
      }
      setIsModalOpen(false)
      setSuccesEmail(true)
      setError("")
    } catch (error) {
      console.error(error);
      setErrorEmail(true)
      
    }
  }

  return (
    <AnimatePresence>
      {isModalOpen && (
        <motion.div
          key="modal-background"
          onClick={() => setIsModalOpen(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-lg shadow-lg p-6 font-poppins w-[500px] mx-4 border border-gray-100"
          >
            <div className="flex items-center gap-3 mb-6">
              <Mail className="w-6 h-6 text-text" />
              <h2 className="text-xl font-semibold text-text">
                Restablecer Contraseña
              </h2>
            </div>

            <form onSubmit={handleSubmit} >
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-text mb-1"
                >
                  Correo electrónico
                </label>
                <input
                value={correo}
                onChange={e =>  setCorreo(e.target.value) }
                  type="email"
                  id="email"
                  className="w-full px-3 py-2 border bg-background text-text border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Ej: usuario@correo.com"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition-colors duration-200 flex items-center justify-center gap-2"
              >
                <Mail className="w-4 h-4" />
                <span>Enviar Instrucciones</span>
              </button>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}